<template>

    <div>

        <div class="mb-4">

            <div class="d-flex justify-content-between text-align-center">
                <BButtonGroup>
                    <BButton variant="primary" @click="filterActive = !filterActive">
                        <i class="fad fa-filter mr-2"/> <span class="font-weight-500">Filtr</span>
                    </BButton>
                    <BButton
                        variant="danger"
                        @click="resetFilters"
                        v-if="isFilterUsed"
                    >
                        <i class="far fa-times"/>
                    </BButton>
                </BButtonGroup>
            </div>

            <BCollapse :visible="filterActive || isFilterUsed" class="mt-3 bg-little-gray p-3">
                <BRow class="mb-3">
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Zakázka:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-orderNumber"
                        >
                            <BFormInput
                                v-model="filterRequest.filter.orderNumber"
                                @change="filterUpdated"
                                id="filter-orderNumber"
                                size="sm"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Odběrné místo:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-supplyPoint"
                        >
                            <BFormInput
                                v-model="filterRequest.filter.supplyPoint"
                                @change="filterUpdated"
                                id="filter-supplyPoint"
                                size="sm"
                            />
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-3">
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Zákazník:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-customer"
                        >
                            <BFormInput
                                v-model="filterRequest.filter.customer"
                                @change="filterUpdated"
                                id="filter-customer"
                                size="sm"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Technik:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-worker"
                        >
                            <BFormInput
                                v-model="filterRequest.filter.worker"
                                @change="filterUpdated"
                                id="filter-worker"
                                size="sm"
                            />
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-3">
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Čas zahájení:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-scheduledStartTime"
                        >
                            <DatePicker
                                v-model="filterRequest.filter.scheduledStartTime"
                                @input="filterUpdated"
                                id="filter-scheduledStartTime"
                                type="date"
                                format="DD.MM.YYYY"
                                value-type="YYYY-MM-DD"
                                time-title-format="DD.MM.YYYY"
                                placeholder="Vybrat datum"
                                input-class="form-control form-control-sm"
                                range
                                :show-second="false"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Stav:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-type"
                        >
                            <BFormSelect
                                v-model="filterRequest.filter.status"
                                :options="orderStatus.arrayList()"
                                @change="filterUpdated"
                                id="filter-type"
                                name="type"
                                value-field="id"
                                text-field="text"
                                size="sm"
                            >
                                <template #first>
                                    <BFormSelectOption :value="null">-- Vybrat --</BFormSelectOption>
                                </template>
                            </BFormSelect>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Adresa:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-address"
                        >
                            <BFormInput
                                v-model="filterRequest.filter.address"
                                @change="filterUpdated"
                                id="filter-address"
                                size="sm"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            class="mb-0"
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Montážní list:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-assemblySheet"
                        >
                            <BFormSelect
                                v-model="filterRequest.filter.assemblySheet"
                                :options="list.assemblySheet"
                                @change="filterUpdated"
                                name="type"
                                id="input-assemblySheet"
                                value-field="id"
                                text-field="text"
                                size="sm"
                            >
                                <template #first>
                                    <BFormSelectOption :value="null">-- Vybrat --</BFormSelectOption>
                                </template>
                            </BFormSelect>
                        </BFormGroup>
                    </BCol>
                </BRow>
            </BCollapse>
        </div>

        <BTable
            ref="table"
            :fields="fields"
            :busy="isLoading"
            :current-page.sync="filterRequest.currentPage"
            :per-page.sync="filterRequest.perPage"
            :sort-by.sync="filterRequest.sortBy"
            :sort-desc.sync="filterRequest.sortDesc"
            :items="myProvider"
            tbody-tr-class="border-bottom"
            thead-tr-class="border-bottom"
            hover
            sort-icon-left
            borderless
            class="mb-0"
            no-sort-reset
            @context-changed="gridUpdated"
            show-empty
        >
            <template v-slot:table-busy>
                <TableLoading/>
            </template>
            <template v-slot:empty>
                <TableWithoutRecords/>
            </template>
            <template v-slot:cell(status)="data">
                {{ orderStatus.getItem(data.item.status).text }}
            </template>
            <template v-slot:cell(action)="data">
                <RouterLink :to="{name: 'order_show', params: {id: data.item.id}}" class="btn btn-primary btn-sm">
                    <i class="fal fa-eye"/>
                </RouterLink>
            </template>
        </BTable>
        <div class="mt-3">
            <strong>Celkem záznamů:</strong> {{ totalRecords }}
        </div>

        <TablePaginator :total-records="totalRecords" :filter-request="filterRequest" hide-go-to-end-buttons/>

    </div>

</template>

<script>
import {mapGetters} from "vuex"
import ServiceOrderStatus from "@/Model/Enum/service_order_status"
import SimpleFormRequest from "@/NewModel/Common/SimpleFormRequest"
import TableLoading from "@/Module/Common/UI/Table/TableLoading.vue"
import TablePaginator from "@/Module/Common/UI/Table/TablePaginator.vue"
import TableWithoutRecords from "@/Module/Common/UI/Table/TableWithoutRecords.vue"
import Vue from "vue"

export default {

    components: {
        TableLoading,
        TablePaginator,
        TableWithoutRecords,
    },

    data() {
        return {
            orderStatus: ServiceOrderStatus,
            filterRequest: this.buildFilterRequest(),
            list: {
                assemblySheet: [
                    {id: 'yes', text: 'S montážním listem'},
                    {id: 'no', text: 'Bez montážního listu'},
                ],
            },
            filterActive: false,
            fields: [
                {
                    key: 'orderNumber',
                    label: 'Zakázka',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle w-10',
                },
                {
                    key: 'supplyPoint',
                    label: 'Odběrné místo',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle',
                },
                {
                    key: 'customer',
                    label: 'Zákazník',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle',
                },
                {
                    key: 'address',
                    label: 'Adresa',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle',
                },
                {
                    key: 'worker',
                    label: 'Technik',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle',
                },
                {
                    key: 'scheduledStartTime',
                    label: 'Čas zahájení',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle',
                    formatter: value => {
                        return Vue.filter('prettyDateTimeShort')(value)
                    },
                },
                {
                    key: 'status',
                    label: 'Stav',
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle w-5',
                },
                {
                    key: 'action',
                    label: 'Akce',
                    thClass: 'font-weight-700',
                    class: 'text-right w-5',
                },
            ],
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/getUser',
            isLoading: 'order/isLoading',
            hasRecords: 'order/hasOrders',
            records: 'order/getOrders',
            totalRecords: 'order/getTotalOrders',
        }),
        gridName: () => '_orderGridFilter',
        isFilterUsed() {
            return this.filterRequest.filter.orderNumber !== ''
                || this.filterRequest.filter.supplyPoint !== ''
                || this.filterRequest.filter.customer !== ''
                || this.filterRequest.filter.address !== ''
                || this.filterRequest.filter.worker !== ''
                || this.filterRequest.filter.scheduledStartTime.length !== 0
                || this.filterRequest.filter.status !== null
                || this.filterRequest.filter.assemblySheet !== null
        },
    },

    created() {
        if (this.$cookies.isKey(this.gridName) && this.user.filterSave) {
            this.filterRequest = SimpleFormRequest.restore(this.$cookies.get(this.gridName))
        }
    },

    mounted() {
        this.filterUpdated()
        this.loadApplianceTypes()
    },

    methods: {

        loadApplianceTypes() {
            this.$store.dispatch("appliance/types/findAllActiveTypes")
        },

        buildFilterRequest() {
            return new SimpleFormRequest({
                orderNumber: '',
                supplyPoint: '',
                customer: '',
                address: '',
                worker: '',
                scheduledStartTime: [],
                status: null,
                assemblySheet: null,
            }, "scheduledStartTime", 10, true)
        },

        gridUpdated(ctx) {
            if (ctx) {
                this.filterRequest.sortBy = ctx.sortBy
                this.filterRequest.sortDesc = ctx.sortDesc
                this.saveFilter()
            }
        },

        saveFilter() {
            if (this.user.filterSave) {
                this.$cookies.set(this.gridName, this.filterRequest.store())
            }
        },

        filterUpdated(resetPage = false) {
            if (resetPage) {
                this.filterRequest.currentPage = 1
            }
            this.saveFilter()
            this.$refs.table.refresh()
        },

        myProvider(ctx, callback) {
            let items = []
            this.$store.dispatch("order/clearAll")
            this.$store.dispatch("order/getFilteredRecords", this.filterRequest)
                .then((response) => {
                    callback(response)
                })
                .catch(() => {
                    callback([])
                })
            return items || []
        },

        resetFilters() {
            this.filterActive = false
            this.filterRequest = this.buildFilterRequest()
            this.filterUpdated()
        },

    },

}
</script>
